import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({providedIn: 'root'})
export class LayoutService {

    // SERVICE
    private readonly bpObserver:      BreakpointObserver                     = inject(BreakpointObserver);

    // BREAKPOINTS
    private readonly MOBILE_QUERY:    string                                 = '(max-width: 767px)';

    // STATE
    private readonly state:           WritableSignal<BreakpointState | null> = signal(null);
    public  readonly isMobile:        Signal<boolean>                        = computed((): boolean => this.state()?.breakpoints[this.MOBILE_QUERY] ?? false);
    public  readonly isLandscape:     Signal<boolean>                        = computed((): boolean => this.state()?.breakpoints[Breakpoints.HandsetLandscape] ?? false);
    private          isTracking:       boolean                                = false;


    // METHODS
    public trackLayout(): void {

        if(this.isTracking) return;
        this.isTracking = true;

        this.bpObserver.observe([Breakpoints.Handset, this.MOBILE_QUERY]).subscribe({
            next:  (value: BreakpointState): void => this.state.set(value),
            error: (e): void => console.error('Error observing breakpoints', e)
        });

    }

}
